import { AodGipFactory, useGipAodFactory } from '../gip/GipAodFactory';

export function useGipAltAodFactory(): AodGipFactory {
  return useGipAodFactory();
}
